import { AxiosRequestConfig } from 'axios';
import { has } from 'lodash-es';
import { userImplement } from '@/config/hooks/user';
import { getProductId } from '@/infrastructure/product-info';
import { getCookie } from '@raft/utils/src/cookie';

/**
 * 请求拦截器
 * @param config
 */
export const onReqFulfilled = (config: AxiosRequestConfig) => {
  const newConfig = { ...config };
  const token = userImplement.getBuglyToken?.();
  newConfig.headers['X-CSRFToken'] = getCookie('csrftoken');

  // 部分场景，调用方需要自定义x-productID，比如退出产品时
  if (!has(newConfig.headers, 'X-ProductID')) {
    newConfig.headers['X-ProductID'] = getProductId();
  }

  if (token) {
    newConfig.headers.Authorization = token;
  }
  return newConfig;
};
